import { useCallback } from 'react';
import { Link } from 'react-router-dom';

import { buscarMeusPedidos } from '@/api/conta';
import { useRequisicao } from '@/hooks/useRequisicao';
import { formatarDataHora, formatarMoeda } from '@/lib/formato';

import {
  Carregando,
  Cartao,
  ErroCarregamento,
  EstadoVazio,
  Secao,
  Status,
} from './ContaUI';

export default function Pedidos() {
  const buscar = useCallback(buscarMeusPedidos, []);
  const { dados, carregando, erro, recarregar } = useRequisicao(buscar);

  if (carregando) {
    return (
      <Secao titulo="Pedidos">
        <Carregando />
      </Secao>
    );
  }

  if (erro) {
    return (
      <Secao titulo="Pedidos">
        <ErroCarregamento onTentarNovamente={recarregar} />
      </Secao>
    );
  }

  const pedidos = dados ?? [];

  return (
    <Secao titulo="Pedidos" descricao="Compras feitas na loja do clube">
      {pedidos.length === 0 ? (
        <EstadoVazio
          titulo="Nenhum pedido por aqui"
          descricao="Seus pedidos da loja aparecem nesta lista, com itens e código de rastreio."
          acao={
            <Link
              to="/"
              className="bg-wine hover:bg-wine-deep rounded-full px-5 py-2.5 text-xs font-bold tracking-[0.14em] text-white uppercase transition-colors"
            >
              Ver a loja
            </Link>
          }
        />
      ) : (
        <ul className="space-y-3">
          {pedidos.map((pedido) => (
            <li key={pedido.id}>
              <Cartao>
                <div className="flex items-start justify-between gap-4">
                  <div className="min-w-0">
                    <h3 className="text-ink font-medium">
                      {formatarMoeda(pedido.totalInCents)}
                    </h3>
                    <p className="text-ink-soft/70 mt-1 text-sm">
                      {formatarDataHora(pedido.createdAt)}
                      {pedido.billingType ? ` · ${pedido.billingType}` : ''}
                    </p>

                    {pedido.items?.length > 0 && (
                      <ul className="text-ink-soft/70 mt-3 space-y-1 text-sm">
                        {pedido.items.map((item, i) => (
                          <li key={i}>
                            {item.quantity}× {item.productName}
                            <span className="text-ink-soft/50">
                              {' '}
                              · {formatarMoeda(item.priceInCents)}
                            </span>
                          </li>
                        ))}
                      </ul>
                    )}

                    {pedido.trackingCode && (
                      <p className="text-ink-soft/50 mt-3 text-xs">
                        Rastreio:{' '}
                        <span className="text-ink-soft font-medium">
                          {pedido.trackingCode}
                        </span>
                      </p>
                    )}
                  </div>
                  <Status valor={pedido.status} />
                </div>
              </Cartao>
            </li>
          ))}
        </ul>
      )}
    </Secao>
  );
}
